import { Accept, ErrorCode } from 'react-dropzone';

import isPlural from '@/helpers/isPlural';

export interface FileWithPreview extends File {
  preview: string;
}

export const getErrorMessage = ({
  errorCode,
  maxFiles,
  maxSize,
  acceptedFileTypes,
}: {
  errorCode: ErrorCode;
  acceptedFileTypes?: Accept;
  maxFiles?: number;
  maxSize?: number;
}) => {
  const errorMessages: Record<ErrorCode, string> = {
    'file-invalid-type': acceptedFileTypes
      ? `File needs to be one of ${Object.values(acceptedFileTypes).join(', ')}`
      : 'Invalid file type',
    'file-too-large': maxSize ? `Maximum file size is ${maxSize / 10000} MB` : 'File too large',
    'file-too-small': 'File too small',
    'too-many-files': maxFiles
      ? `Only ${maxFiles} ${isPlural({ one: 'file', more: 'files', number: maxFiles })}`
      : 'Too many files',
  };

  return errorMessages[errorCode];
};

export const createFilePreview = (file: File): FileWithPreview => {
  return Object.assign(file, {
    preview: URL.createObjectURL(file),
  });
};

export const getUploadButtonText = (type: string, maxFiles?: number) => {
  return type === 'zip' ? 'Upload Zip' : isPlural({ one: 'Upload File', more: 'Upload Files', number: maxFiles ?? 0 });
};

export const thumbStyles = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 50,
  height: 50,
  padding: 4,
};

export const thumbInnerStyles = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
};

export const imgStyles = {
  display: 'block',
  width: 'auto',
  height: '100%',
};
